import { render, staticRenderFns } from "./evidence_info.vue?vue&type=template&id=17b6bd3e"
import script from "./evidence_info.vue?vue&type=script&lang=js"
export * from "./evidence_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports